import Pages from '../../../config/Pages';
import { Route } from '../../../core/utils/RouteMixins';
import { permissionEnums } from '../../../core/enums/PermissionEnums';
import Listagem from './indicadorListagem/IndicadorListagem';
import Form from './indicadorForm/IndicadorForm';

const indicadorRoutes = [
    Route(['Indicador', 'pi pi-file'], Pages.sei.indicador.url.list, Listagem, [
        permissionEnums.INDICADOR_VISUALIZAR,
    ]),
    Route(null, Pages.sei.indicador.url.edit, Form, [permissionEnums.INDICADOR_EDITAR]),
    Route(null, Pages.sei.indicador.url.view, Form, [permissionEnums.INDICADOR_CONSULTAR]),
];

export default indicadorRoutes;
